import React, { useMemo } from 'react';
import cc from 'classnames';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import { ghsFormatter } from 'utils/formatters';
import { IAccount } from 'store/accounts.model';

import styles from './AccountCard.module.css';

interface ICardProps {
  account: IAccount;
  isActive: boolean;
  onClick: () => void;
}

const AccountCard = (props: ICardProps) => {
  const { account, onClick, isActive } = props;

  const [fmtAvailableBalance, fmtBookBalance] = useMemo<string[]>(
    () => [`${+(account.availableBalance) < 0 ? '-' : ''}
        ${ghsFormatter.format(+account.availableBalance).split(/\s/, 2)[1]}`,
    `${+account.bookBalance < 0 ? '-' : ''}${ghsFormatter.format(+account.bookBalance).split(/\s/, 2)[1]}`,
    ],
    [account],
  );

  return (
    <Card className={cc(styles.root, isActive ? styles.activeAccount : '')} elevation={0}>
      <CardActionArea onClick={onClick}>
        <CardContent className={styles.content}>
          <div className={styles.acctType}>
            <span className={styles.typeLabel}>{account.accountType || 'Current'}</span>
            {account.primaryAccount ? <span className={styles.primaryLabel}>Primary</span> : ''}
          </div>
          <div className={styles.balanceSect}>
            <div>
              <p className={styles.balanceLabel}>Balance:</p>
              <p className={styles.balance}>
                {account.currency} {fmtAvailableBalance}
              </p>
            </div>
          </div>

          <div className={styles.bookSect}>
            <div>
              <p className={styles.balanceLabel}>Book Balance:</p>
              <p className={styles.bookBalance}>
                {account.currency} {fmtBookBalance}
              </p>
            </div>
            <div>
              <span>{account.accountNumber}</span>
            </div>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AccountCard;
